﻿import * as DTOs from '@/types/api/profile';
import { get, post } from '@/services/api-client';

export default {
    getBaseInfo: () => get<DTOs.ProfileBaseInfoDTO>('/profile/GetBaseInfo'),

    changeBaseInfo: (data: FormData) => post('/profile/ChangeBaseInfo', data),

    verifyCurrentPassword: (data: DTOs.VerifyCurrentPasswordFormDTO) => post('/profile/VerifyCurrentPassword', data),

    changeUserPassword: (data: DTOs.ChangePasswordFormDTO) => post('/profile/ChangePassword', data),

    getUserAvatar: (id: number) =>
        get<Blob>('/profile/avatar', {
            query: { userId: id },
            responseType: 'blob'
        })
};
